import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getApiUsages(companyId, query) {
	return dataTransferWrap(
		ModulesMap.API_USAGES,
		dtConfig[ModulesMap.API_USAGES].getApiUsages,
		{
			urlParams: {
				companyId,
			},
			params: query,
		}
	)
}

function getApiUsage(companyId, cargoId) {
	return dataTransferWrap(
		ModulesMap.API_USAGES,
		dtConfig[ModulesMap.API_USAGES].getApiUsage,
		{
			urlParams: {
				companyId,
				cargoId,
			},
		}
	)
}

function getApiUsagePreview(companyId, cargoId) {
	return dataTransferWrap(
		ModulesMap.API_USAGES,
		dtConfig[ModulesMap.API_USAGES].getApiUsagePreview,
		{
			urlParams: {
				companyId,
				cargoId,
			},
		}
	)
}

function getApiUsagePopup(companyId, cargoId) {
	return dataTransferWrap(
		ModulesMap.API_USAGES,
		dtConfig[ModulesMap.API_USAGES].getApiUsagePopup,
		{
			urlParams: {
				companyId,
				cargoId,
			},
		}
	)
}

export default {
	getApiUsages,
	getApiUsage,
	getApiUsagePreview,
	getApiUsagePopup,
}

